/**
 * KWC · Sticky Buy Bar
 * ---------------------------------------------------------------------------
 * Presentation + a thin bridge to the NATIVE product form. No second variant
 * system and no second cart:
 *   - Price mirrors Horizon's own <product-price> element (auto-updates on
 *     variant change, because Horizon rewrites that element in place).
 *   - The variant id is read live from the form's input[name="id"] at click
 *     time, so it is always the currently selected variant.
 *   - BUY IT NOW adds that variant via Shopify's /cart/add.js then goes to
 *     /checkout; if anything fails it falls back to clicking the real
 *     add-to-cart button, so the native flow always wins.
 *   - Visibility is driven by an IntersectionObserver on the main buy area.
 *
 * Vanilla, dependency-free, and self-contained. Safe if any hook is missing.
 */
(function () {
  var bar = document.querySelector('[data-kwc-sbb]');
  if (!bar) return;

  var scope = document.querySelector('main[data-template="product"]') || document;
  var form =
    scope.querySelector('form[action$="/cart/add"]') ||
    scope.querySelector('form.shopify-product-form');
  var priceContainer =
    scope.querySelector('.product-details product-price [ref="priceContainer"]') ||
    scope.querySelector('.product-details product-price') ||
    scope.querySelector('product-price');
  var nativeAtc = scope.querySelector('[ref="addToCartButton"]');
  var trigger =
    scope.querySelector('.buy-buttons-block') ||
    (nativeAtc && nativeAtc.closest('add-to-cart-component, product-form-component')) ||
    form;

  var barPrice = bar.querySelector('[data-kwc-sbb-price]');
  var buyBtn = bar.querySelector('[data-kwc-sbb-buy]');
  var labelDefault = (buyBtn && buyBtn.dataset.label) || 'Buy it now';
  var labelSoldOut = (buyBtn && buyBtn.dataset.soldout) || 'Sold out';

  /* --- Price sync: clone Horizon's rendered current price ---------------- */
  function syncPrice() {
    if (!priceContainer || !barPrice) return;
    barPrice.innerHTML = priceContainer.innerHTML;
  }
  syncPrice();
  if (priceContainer && 'MutationObserver' in window) {
    new MutationObserver(syncPrice).observe(priceContainer, {
      childList: true,
      subtree: true,
      characterData: true,
    });
  }

  /* --- Availability sync: mirror the native add-to-cart disabled state --- */
  function syncAvailability() {
    if (!nativeAtc || !buyBtn) return;
    var disabled =
      nativeAtc.disabled === true || nativeAtc.getAttribute('aria-disabled') === 'true';
    buyBtn.disabled = disabled;
    buyBtn.textContent = disabled ? labelSoldOut : labelDefault;
  }
  syncAvailability();
  if (nativeAtc && 'MutationObserver' in window) {
    new MutationObserver(syncAvailability).observe(nativeAtc, {
      attributes: true,
      attributeFilter: ['disabled', 'aria-disabled'],
    });
  }

  /* --- Visibility: show once the main buy area has scrolled ABOVE view --- */
  if (trigger && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var scrolledPast = entry.boundingClientRect.top < 0;
          if (!entry.isIntersecting && scrolledPast) {
            bar.classList.add('is-visible');
          } else {
            bar.classList.remove('is-visible');
          }
        });
      },
      { threshold: 0 }
    );
    io.observe(trigger);
  }

  /* --- BUY IT NOW: current variant -> cart -> checkout, native fallback -- */
  if (buyBtn) {
    buyBtn.addEventListener('click', function () {
      if (buyBtn.disabled) return;
      var idInput = form && form.querySelector('input[name="id"]');
      var variantId = idInput && idInput.value;

      if (!variantId) {
        if (nativeAtc) nativeAtc.click();
        return;
      }

      buyBtn.classList.add('is-loading');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
      })
        .then(function (res) {
          if (!res.ok) throw new Error('add-to-cart failed');
          window.location.href = '/checkout';
        })
        .catch(function () {
          buyBtn.classList.remove('is-loading');
          if (nativeAtc) nativeAtc.click(); // fall back to the native flow
        });
    });
  }
})();
